import { useMemo } from 'react'

import { PreviewMode } from 'services/Store/Project/enums'

import TestGeneralFeedbackElementEditor from './TestGeneralFeedbackElementEditor'
import TestGeneralFeedbackElementPreview from './TestGeneralFeedbackElementPreview'
import type { TestGeneralFeedbackElementType } from './testGeneralFeedbackTypes'

const COMPONENTS_MAP: Partial<Record<PreviewMode, TestGeneralFeedbackElementType>> = {
  editor: TestGeneralFeedbackElementEditor,
  skeleton: TestGeneralFeedbackElementEditor,
}

const TestGeneralFeedbackElement: TestGeneralFeedbackElementType = ({ mode, ...rest }) => {
  const Component = COMPONENTS_MAP[mode.previewMode] || TestGeneralFeedbackElementPreview
  const feedbackMode = useMemo(
    () => ({
      ...mode,
      previewMode: mode.previewMode === PreviewMode.pdf ? mode.previewMode : PreviewMode.feedback,
    }),
    [mode],
  )
  return <Component mode={feedbackMode} {...rest} />
}

export default TestGeneralFeedbackElement
